export const apiEndpoints = {
  termsAndPrivcay: {
    url: "common/terms",
    isMock: false,
  },
  privacyStatement: {
    url: "common/privacy-statement",
    isMock: false,
  },
  exploreLearn: {
    url: "articles/",
    isMock: false,
  },
  exploreArticle: {
    url: "articles/details/",
    isMock: false,
  },
  exploreLearnCategories: {
    url: "articles/categories",
    isMock: false,
  },
  exploreFilterArticles: {
    url: "articles/category/",
    isMock: false,
  },
  getAllProduct: {
    url: "product/",
    isMock: false,
  },
  quizQuestions: {
    url: "quiz/questions",
  },
  setReadStatus: {
    url: "articles/read",
    isMock: false,
  },

  getProfileDetails: {
    url: "user/profile",
    isMock: false,
  },
  getDropdownMasterData: {
    url: "common/master-data",
    isMock: false,
  },
  uploadProfilePicture: {
    url: "user/uploadpicture",
    isMock: false,
  },
  quizResponse: {
    url: "quiz",
    isMock: false,
  },
  submittedQuizResponse: {
    url: "quiz",
    isMock: false,
  },
  getNotification: {
    url: "notifications/",
    isMock: false,
  },
  postNotification: {
    url: "notifications",
    isMock: false,
  },
  insightsData: {
    url: "home/v2",
    isMock: false,
  },
  symptomData: {
    url: "symptom/getall",
    isMock: false,
  },
  trendsBySign: {
    url: "trends",
    isMock: false,
  },
  insightTrends: {
    url: "trends/insights",
    isMock: false,
  },
  insightArticles: {
    url: "trends/insight-articles/",
    isMock: false,
  },
  savePeriodData: {
    url: "symptom/period",
    isMock: false,
  },
  saveFirebaseToken: {
    url: "notifications/savefcm",
    isMock: false,
  },
  saveSymptom: {
    url: "symptom/save",
    isMock: false,
  },
  quizResults: {
    url: "quiz/result",
  },
  pulseRating: {
    url: "symptom/pulse-rating",
    isMock: false,
  },
  getMq6Results: {
    url: "quiz/result",
    isMock: false,
  },
  getTrendsBySign: {
    url: "trends/signs",
    isMock: false,
  },
  logoutUser: {
    url: "user/logout/",
    isMock: false,
  },
  getConsentContent: {
    url: "home/consents",
    // url: "home/consent-list",
    isMock: false,
  },
  postMenopauseStage: {
    url: "user/stage",
    isMock: false,
  },
  getUserSpecificConsent: {
    url: "home/consent-accepted",
    isMock: false,
  },
  saveUserSpecificConsent: {
    url: "home/consent",
    isMock: false,
  },
  dummyApi: {
    url: "home/page/404",
    isMock: false,
  },
  getGuidanceCategory: {
    url: "articles/guidance/categories",
    isMock: false,
  },
  getGuidanceAll: {
    url: "articles/guidance",
    isMock: false,
  },
  guidanceFilterArticles: {
    url: "articles/guidance/category/",
    isMock: false,
  },
  exploreGuidanceArticle: {
    url: "articles/guidance/details/",
    isMock: false,
  },
  contactUs: {
    url: "user/contact/",
    isMock: false,
  },
  getUserToken: {
    url: "authorize/token",
  },
  postUsername: {
    url: "user/onboard/",
    isMock: false,
  },
  deleteUserAccount: {
    url: "user/delete",
    isMock: false,
  },
  checkRegisterMethod: {
    url: "user/method",
    isMock: false,
  },
  faq: {
    url: "common/faq",
    isMock: false,
  },
  guidanceProgress: {
    url: "articles/progress",
    isMock: false,
  },
  aboutContent: {
    url: "common/about",
    isMock: false,
  },
  saveVideoProgress: {
    url: "articles/video-progress",
    isMock: false,
  },
  contactUsNote: {
    url: "common/contact",
    isMock: false,
  },
  uploadProfilePictureV2: {
    url: "user/file",
    isMock: false,
  },
  deleteProfilePicture: {
    url: "user/remove",
    isMock: false,
  },
  saveSettings: {
    url: "user/settings/save",
    isMock: false,
  },
  getSettings: {
    url: "user/settings/get/v2",
    isMock: false,
  },
  utmSourceUpdate: {
    url: "user/coupon",
    isMock: false,
  },
  countrySelectionList: {
    url: "common/country",
    isMock: false,
  },
  countrySaveSettings: {
    url: "user/settings/save/v2",
    isMock: false,
  },
  getPulseCheckDetails: {
    url: "symptom/all-ratings",
    isMock: false,
  },
  getProductDetails: {
    url: "product",
    isMock: false,
  },
  marketingConsent: {
    url: "home/marketing-consent",
    isMock: false,
  },
  appflyerTrack: {
    url: "home/appflyer-track",
    isMock: false,
  },
};
